import { axios } from "./axios";
import {
  ADD_TRAVEL_INFORMATION,
  ADD_UPDATE_TRAVEL_INFORMATION_EXPENSES,
  ADD_UPDATE_TRAVEL_INSPECTION_TIME,
  DELETE_TRAVEL_INFORMATION,
  UPDATE_TRAVEL_INFORMATION,
  UPDATE_TRAVEL_NOTES,
  ADD_MACHINE_IN_RUNNING_INSPECTION
} from "../constants/paths";
import {
  travelNotesDTO,
  updateTravelAndInspectionHoursDTO,
} from "./interface/travelInformation";
import { AxiosResponse } from "axios";

/**
 * travelInformation DTO
 * @export
 * @typedef {travelInformationDTO}
 */

export type travelInformationDTO = {
  id: number | null;
  inspection: string | null;
  travel_start: string;
  travel_stop: string;
  inspection_start: string;
  inspection_stop: string;
  description: string | null;
};

/**
 * Add Travel Information Request API Call
 * @param {travelInformationDTO} data
 * @returns {Promise<any>}
 */
export const addTravelInformation = (
  data: travelInformationDTO
): Promise<any> => {
  return axios.post(ADD_TRAVEL_INFORMATION, data);
};

/**
 * Update Travel Inforamtion Request API Call
 * @param {travelInformationDTO} data
 * @returns {Promise<any>}
 */
export const updateTravelInformation = (
  data: travelInformationDTO
): Promise<any> => {
  return axios.post(UPDATE_TRAVEL_INFORMATION, data);
};

/**
 * Delete Travel Information DTO
 * @export
 * @typedef {delTravelInformationDTO}
 */

export type delTravelInformationDTO = {
  id: number;
};

/**
 * Update Travel Inforamtion Request API Call
 * @param {travelInformationDTO} data
 * @returns {Promise<any>}
 */
export const deleteTravelInformationAPI = (
  data: delTravelInformationDTO
): Promise<any> => {
  return axios.get(DELETE_TRAVEL_INFORMATION + "/" + data.id);
};

/**
 * Travel Information Expenses DTO
 * @export
 * @typedef {travelInformationExpensesDTO}
 */

export type travelInformationExpensesDTO = {
  id: number | null;
  inspection_id: string | null;
  tolls_cost: number | null;
  meals_cost: number | null;
  lodging_cost: number | null;
  mileage_cost: number | null;
  misc_cost: number | null;
};

/**
 * Update if exist else add Travel Inforamtion Expenses Request API Call
 * @param {travelInformationExpensesDTO} data
 * @returns {Promise<any>}
 */
export const updateTravelInformationExpensesAPI = (
  data: travelInformationExpensesDTO
): Promise<any> => {
  return axios.post(ADD_UPDATE_TRAVEL_INFORMATION_EXPENSES, data);
};

/**
 * Update if exist else add Travel And Inspection Time Request API Call
 * @param {updateTravelAndInspectionHoursDTO} data
 * @returns {Promise<any>}
 */
export const updateTravelAndInspectionHoursAPI = (
  data: updateTravelAndInspectionHoursDTO
): Promise<any> => {
  return axios.post(ADD_UPDATE_TRAVEL_INSPECTION_TIME, data);
};

/**
 * Update Travel Notes Request API Call
 * @param {travelNotesDTO} data
 * @returns {Promise<any>}
 */
export const updateTravelNotes = (data: travelNotesDTO): Promise<any> => {
  return axios.post(UPDATE_TRAVEL_NOTES, data);
};

//add new machine in running inspection
export const addMachineInCurrentInspection = (data: any):Promise<any> => {
  return axios.post(ADD_MACHINE_IN_RUNNING_INSPECTION, data);
};